import axios from 'axios'
import qs from 'qs'

let Env = function () {
  let Env = {
    queryUrl: '//api.show.vizen.cn',
    WJPlatformUrl: '//show.vizen.cn/weixin/',
    testEnv: false
  }
  // 本地环境
  if (/-debug|localhost|192.168|0.0.0.0|env=0/.test(window.location.href)) {
    Env.queryUrl = '//api.show.test.vizen.cn'
    Env.WJPlatformUrl = '//show.test.vizen.cn/weixin/'
    Env.testEnv = true
  }
  // 线上环境
  if (/env=1/.test(window.location.href)) {
    Env.queryUrl = '//api.show.vizen.cn'
    Env.WJPlatformUrl = '//show.vizen.cn/weixin/'
    Env.testEnv = false
  }
  // 测试环境
  if (/env=2/.test(window.location.href)) {
    Env.queryUrl = '//api.show.test.vizen.cn'
    Env.WJPlatformUrl = '//show.test.vizen.cn/weixin/'
    Env.testEnv = true
  }
  // 预生产环境
  if (/env=3/.test(window.location.href)) {
    Env.queryUrl = '//api.show.pre.vizen.cn'
    Env.WJPlatformUrl = '//show.vizen.cn/weixin/'
    Env.testEnv = false
  }
  // dev环境
  if (/env=4/.test(window.location.href)) {
    Env.queryUrl = '//api.show.dev.vizen.cn'
    Env.WJPlatformUrl = '//show.test.vizen.cn/weixin/'
    Env.testEnv = true
  }
  return Env
}

let interceptor = {
  success (res) { return res },
  error (err) {
    console.log(err)
  }
}

// 默认接口头部域名
axios.defaults.baseURL = '//api.show.vizen.cn'
axios.defaults.withCredentials = true
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
axios.interceptors.response.use(interceptor.success, interceptor.error)
var instance2 = axios.create({
})
// 默认接口头部域名
instance2.defaults.baseURL = '//luna.vizen.cn/luna-web/'
instance2.defaults.withCredentials = true
instance2.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
instance2.interceptors.response.use(interceptor.success, interceptor.error)
/* *
 * axios默认发送post请求方式为application/json
 * 若需要使用 application/x-www-form-urlencoded 格式发送
 * 需要把参数通过qs转成字符串
 * This is only applicable for request methods 'PUT', 'POST', and 'PATCH'
 */
axios.defaults.transformRequest = [
  function (data) {
    return qs.stringify(data)
  }
]

/* *
 * 添加vue全局插件api
 * 通过添加Vue实例方法，调用：vm.$api
 */
export default {
  install (Vue) {
    Vue.prototype.$api = {
      getArticle (articleId) {
        return instance2.get('api/article/' + articleId)
      },
      // 应用信息
      getAppInfo (appId) {
        return axios.get('/api/app/V2/' + appId)
      },
      getAllInfoMarker (appId, type = 'all') {
        return axios.get('/api/app/marker/all?appId=' + appId + '&markerType=' + type)
      },
      // 应用列表
      getAppList (appId) {
        return axios.get('/api/app/info/' + appId, { params: { preview: 1 } })
      },
      // 获取点赞数和浏览数
      getAppZanNum (appId) {
        return axios.get('/api/app/actionsCount', { params: { appId: appId } })
      },
      // 用户浏览计数  无返回数据,每执行一次,数据库该markerId对应的浏览次数(visitCount )＋1
      getVisitCount (params) {
        return axios.get(`/api/app/browse?appId=${params.appId}`, { params })
      },
      // 点赞+1 无返回数据,每执行一次,数据库该appId对应的点赞次数(thumbUpCount )+1
      getThumbUpCount (params) {
        return axios.post(`/api/app/thumbUp?appId=${params.appId}`, params)
      },
      // 获取今天是否点击过赞 一天只能点赞一次 点击后不能取消
      getThumbUpStatus (params) {
        return axios.get(`/api/app/thumbUpStatus?appId=${params.appId}`, { params })
      },
      // 全景及marker信息
      getPanoMarker (paramsData) {
        return axios.get('/api/app/facility/marker', { params: { facilityId: paramsData.facilityId, materialId: paramsData.materialId } })
      },
      // 实体信息
      getEntityInfo (entityId) {
        return axios.get('/api/app/entity/' + entityId)
      },
      // 设施信息
      getFacilityInfo (entityId) {
        return axios.get('/api/app/facility/V2/' + entityId)
      },
      // 设施信息
      getGroupInfo (groupId) {
        return axios.get('/api/group/' + groupId)
      }
    }
  }
}
